// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.divquizsolve > .q-checkbox {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  padding-top: 6px;\n  padding-left: 12px;\n}\n.divquizsolve > .q-checkbox:last-child {\n  padding-bottom: 12px;\n}\n.divquizsolve > .q-checkbox__label {\n  font-size: 1.15em !important;\n}\n.divquizsolve > .lawspan {\n  font-size: 1.2em;\n  color: blue;\n}\n", ""]);
// Exports
module.exports = exports;
